<template>
  <div class="bingo-reward-cards">
    <div
      v-for="prize in bingoPrizes"
      :key="`bingo-${prize.bingo_number}`"
      class="bingo-reward-cards__card bingo-reward-cards__card--bingo"
      :class="{ 'bingo-reward-cards__card--locked': !prize.unlocked }"
    >
      <div class="bingo-reward-cards__icon-wrap">
        <v-icon v-if="!prize.unlocked" color="grey-darken-1" size="32">mdi-lock-outline</v-icon>
        <icon v-else fill="#757575" height="32" width="32">TrophyNew</icon>
      </div>
      <div class="bingo-reward-cards__body">
        <h3 class="bingo-reward-cards__title">{{ prize.heading }}</h3>
        <p class="bingo-reward-cards__detail">
          <span>{{ prize.name }} — {{ prize.description }}</span>
        </p>
      </div>
    </div>
    <div
      v-if="hasBlackout"
      class="bingo-reward-cards__card bingo-reward-cards__card--blackout"
      :class="{ 'bingo-reward-cards__card--locked': !blackoutUnlocked }"
    >
      <div class="bingo-reward-cards__icon-wrap">
        <v-icon
          :color="blackoutUnlocked ? 'grey-darken-1' : 'grey-darken-1'"
          size="32"
        >{{ blackoutUnlocked ? 'mdi-gift-outline' : 'mdi-lock-outline' }}</v-icon>
      </div>
      <div class="bingo-reward-cards__body">
        <h3 class="bingo-reward-cards__title">Blackout Bonus</h3>
        <p class="bingo-reward-cards__detail">
          <span>{{ blackoutPrizeName }} — Fill every square</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BingoRewardCards',
  props: {
    bingoPrizes: {
      type: Array,
      default: () => []
    },
    hasBlackout: {
      type: Boolean,
      default: false
    },
    blackoutPrizeName: {
      type: String,
      default: ''
    },
    blackoutUnlocked: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.bingo-reward-cards {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  gap: 8px !important;
}

.bingo-reward-cards__card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  border-radius: 12px;
  padding-top: .625rem !important;
  padding-bottom: .625rem !important;
  padding-left: .75rem !important;
  padding-right: .75rem !important;

  &--bingo {
    background-color: #e3f2fd;
    align-items: center;
  }

  &--blackout {
    background-color: #fff3e0;
  }

  &--locked {
    opacity: 0.55;
  }
}

.bingo-reward-cards__icon-wrap {
  flex-shrink: 0;
}

.bingo-reward-cards__body {
  flex: 1;
  min-width: 0;
}

.bingo-reward-cards__title {
  font-size: 1rem;
  font-weight: 700;
  color: #212121;
  margin: 0 0 6px 0;
  line-height: 1.3;
}

.bingo-reward-cards__detail {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.875rem;
  color: #212121;
  margin: 0;
  line-height: 1.4;
}

.bingo-reward-cards__detail-icon {
  flex-shrink: 0;
}

.bingo-reward-cards__icon-wrap svg {
    width: 1.25rem;
    height: 1.25rem;
}
.bingo-reward-cards__icon-wrap i {
    font-size: 1.25rem !important;
}
h3.bingo-reward-cards__title {
    font-size: .875rem !important;
    line-height: 1.25rem !important;
    margin: 0 !important;
    font-weight: 600 !important;
    color: rgba(0, 0, 0, .75) !important;
}

.bingo-reward-cards__icon-wrap, .bingo-reward-cards__icon-wrap,.bingo-reward-cards__icon-wrap i {
    width: 1.25rem !important;
    height: 1.25rem !important;
}

.bingo-reward-cards__card.bingo-reward-cards__card--blackout {
    align-items: center;
}

p.bingo-reward-cards__detail span {
    color: #737f8c;
    font-size: .75rem;
    line-height: 1rem;
}
</style>
